import Marquee from "react-fast-marquee";
import { DiamondMark } from "./DiamondMark";

const ITEMS = [
  "Balloon Garlands",
  "Intimate Dinners",
  "Private Chef Catering",
  "Luxury Picnics",
  "Anniversaries",
  "Birthday Soirées",
  "Event Styling",
];

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="bg-[#F2D8D5]/40 border-y border-[#E5D3B3]/60 py-6 overflow-hidden">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center gap-10 mx-10">
            <span className="font-serif italic text-2xl lg:text-3xl text-[#2A2423]/80 whitespace-nowrap">{item}</span>
            <DiamondMark className="w-4 h-4 text-[#D8A7A1]" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
